import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private readonly _isLoading = signal<boolean>(false);
  private readonly _message = signal<string>('Cargando...');

  readonly isLoading = computed(() => this._isLoading());
  readonly message = computed(() => this._message());

  show(message = 'Cargando...'): void {
    this._message.set(message);
    this._isLoading.set(true);
  }

  hide(): void {
    this._isLoading.set(false);
  }
}
